import { defineComponent, computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useCashierSettingsStore } from '@/store/cashier-settings/cashier-settings.store';
import AddCountryDialog from '@/layouts/cashier-settings-page/modals/add-country-dialog/add-country-dialog.vue';
import ConfigList from '@/layouts/cashier-settings-page/config-list/config-list.vue';
import SettingsScreen from '@/layouts/cashier-settings-page/settings-screen/settings-screen.vue';

export default defineComponent({
  name: 'CashierSettingsPage',
  components: {
    AddCountryDialog,
    ConfigList,
    SettingsScreen,
  },
  setup() {
    const { selectedCountryConfig } = storeToRefs(useCashierSettingsStore());
    const isAddCountryDialogVisible = ref(false);
    const isSettingsScreenVisible = computed(() => Boolean(selectedCountryConfig.value.country));

    const openAddCountryDialog = (): void => {
      isAddCountryDialogVisible.value = true;
    };

    return {
      openAddCountryDialog,
      isSettingsScreenVisible,
      isAddCountryDialogVisible,
    };
  },
});
